import { Link, LinkOptions } from "@/components/link";
import { PATH_PAYROLL_AGGREGATION } from "@/constants";
import { FileUser } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";
import { usePayrollParams } from "../hooks/usePayrollParams";

interface PayrollAggregateLinkProps {
  options?: LinkOptions;
}

export const PayrollAggregateLink = memo(
  ({ options }: PayrollAggregateLinkProps) => {
    const { t } = useTranslation();
    const { payrollId } = usePayrollParams();

    return (
      <Link
        to={generatePath(PATH_PAYROLL_AGGREGATION, {
          payrollId,
        })}
        options={options}
      >
        <FileUser className="w-5 h-5 mr-1" />
        {t("payrolls.aggregatePayroll.link")}
      </Link>
    );
  },
);
